/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { AsapStartDate } from './';
import {
    AsapStartDateFromJSON,
    AsapStartDateFromJSONTyped,
    AsapStartDateToJSON,
} from './';
import type { ChosenStartDate } from './';
import {
    ChosenStartDateFromJSON,
    ChosenStartDateFromJSONTyped,
    ChosenStartDateToJSON,
} from './';
import type { StartDateType } from './';
import {
    StartDateTypeFromJSON,
    StartDateTypeFromJSONTyped,
    StartDateTypeToJSON,
} from './';
import type { UnknownStartDate } from './';
import {
    UnknownStartDateFromJSON,
    UnknownStartDateFromJSONTyped,
    UnknownStartDateToJSON,
} from './';

/**
 * 
 * @export
 * @interface StartDate
 */
export interface StartDate {
    /**
     * 
     * @type {StartDateType}
     * @memberof StartDate
     */
    type: StartDateType;
}

/**
 * Check if a given object implements the StartDate interface.
 */
export function instanceOfStartDate(value: object): value is StartDate {
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function StartDateFromJSON(json: any): StartDate {
    return StartDateFromJSONTyped(json, false);
}

export function StartDateFromJSONTyped(json: any, ignoreDiscriminator: boolean): StartDate {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['type'] === 'AS_SOON_AS_POSSIBLE') {
            return AsapStartDateFromJSONTyped(json, true);
        }
        if (json['type'] === 'CHOSEN_DATE') {
            return ChosenStartDateFromJSONTyped(json, true);
        }
        if (json['type'] === 'UNKNOWN') {
            return UnknownStartDateFromJSONTyped(json, true);
        }
    }
    return {
        
        'type': StartDateTypeFromJSON(json['type']),
    };
}

export function StartDateToJSON(value?: StartDate | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
        if (value.type === 'AS_SOON_AS_POSSIBLE') {
            return AsapStartDateToJSON(value as AsapStartDate);
        }
        if (value.type === 'CHOSEN_DATE') {
            return ChosenStartDateToJSON(value as ChosenStartDate);
        }
        if (value.type === 'UNKNOWN') {
            return UnknownStartDateToJSON(value as UnknownStartDate);
        }
    }
    return {
        
        'type': StartDateTypeToJSON(value['type']),
    };
}

